<template>
	<div class="card mb-4">
		<div class="card-header bg-info text-light">
			Signup
		</div>
		<div class="card-body">
			<form v-if="formStatus.success !== true" @submit.prevent="submit" class="needs-validation">
				<fieldset class="form-group">
					<label for="fname">First Name</label>
					<input v-model="signupdata.fname" type="text" :class="['form-control', { 'is-invalid':validationErrors.fname }]" id="fname" name="fname">
					<div class="invalid-feedback" v-if="validationErrors.fname" v-text="validationErrors.fname"></div>
				</fieldset>
				<fieldset class="form-group">
					<label for="lname">Last Name</label>
					<input v-model="signupdata.lname" type="text" :class="['form-control', { 'is-invalid':validationErrors.lname }]" id="lname" name="lname">
					<div class="invalid-feedback" v-if="validationErrors.lname" v-text="validationErrors.lname"></div>
				</fieldset>
				<fieldset class="form-group">
					<label for="email">Email</label>
					<input v-model="signupdata.email" type="text" :class="['form-control', { 'is-invalid':validationErrors.email }]" id="email" name="email">
					<div class="invalid-feedback" v-if="validationErrors.email" v-text="validationErrors.email"></div>
				</fieldset>
				<fieldset class="form-group">
					<label for="password">Password</label>
					<input v-model="signupdata.password" type="password" :class="['form-control', { 'is-invalid':validationErrors.password }]" id="password" name="password">
					<div class="invalid-feedback" v-if="validationErrors.password" v-text="validationErrors.password"></div>
				</fieldset>
				<fieldset class="form-group">
					<label for="password_confirm">Confirm Password</label>
					<input v-model="signupdata.password_confirm" type="password" :class="['form-control', { 'is-invalid':validationErrors.password_confirm }]" id="password_confirm" name="password_confirm">
					<div class="invalid-feedback" v-if="validationErrors.password_confirm" v-text="validationErrors.password_confirm"></div>
				</fieldset>
        <fieldset class="form-group">
          <div class="card bg-warning text-white">
            <div class="card-body">
              <label for="lname">Organization Website</label>
              <div class="input-group">
                <input v-model="signupdata.org_website" type="text" :class="['form-control', { 'is-invalid':validationErrors.org_website }]" id="org_website" name="org_website">
                <div class="input-group-append">
                  <button class="btn btn-primary" @click="searchForOrg()" type="button" id="button-addon2"><i class="fa fa-search"></i>&nbsp;&nbsp;Search</button>
                </div>
              </div>
              <small class="form-text">
                Your organization's website is used to determine if the organization has already been created in our system.  If it has, after you complete the Signup form, an email will be sent to an organization Administratator for approval.
              </small>
              <div class="invalid-feedback" v-if="validationErrors.org_website" v-text="validationErrors.org_website"></div>
            </div>
          </div>
        </fieldset>
        <fieldset class="form-group">
          <label for="lname">Organization Name</label>
          <input v-model="signupdata.org_name" type="text" :readonly="didSearchForOrg === false || didFindOrg === true" :disabled="didSearchForOrg === false || didFindOrg === true" :class="['form-control', { 'is-invalid':validationErrors.org_name }]" id="org_name" name="org_name">
          <div class="invalid-feedback" v-if="validationErrors.org_name" v-text="validationErrors.org_name"></div>
        </fieldset>
        <fieldset class="form-group">
          <label for="lname">Organization Type</label>
          <select v-model="signupdata.org_type" :readonly="didSearchForOrg === false || didFindOrg === true" :disabled="didSearchForOrg === false || didFindOrg === true" :class="['form-control', { 'is-invalid':validationErrors.org_type }]" id="org_type" name="org_type">
            <option value="">Please select type...</option>
            <option value="CU">Credit Union</option>
            <option value="BANK">Bank</option>
            <option value="OTHR">Other</option>
          </select>
          <div class="invalid-feedback" v-if="validationErrors.org_type" v-text="validationErrors.org_type"></div>
        </fieldset>
				<button v-if="showFormStatusMessage === false || didSearchForOrg === true" :disabled="didSearchForOrg === false" type="submit" class="btn btn-success" v-text="submitButtonText"></button>
			</form>
      <div v-if="didSearchForOrg === false" class="alert alert-warning" role="alert">
        <h4 class="alert-heading">Before you continue&hellip;</h4>
        Enter your organization's website above and click Search. If it is not found, you will be able to create it.
      </div>
      <div v-if="showFormStatusMessage" :class="['alert', { 'alert-success':formStatus.success, 'alert-danger':formStatus.error }, 'alert-dismissible']" role="alert" style="margin-top:20px">
        <h4 class="alert-heading" v-html="formStatus.statusHeading"></h4>
        <p v-html="formStatus.statusBody"></p>
        <button @click="clearFormStatus()" type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <p>
        By clicking the Signup button or Request to Join Organization button you agree to our <router-link to="terms" target="_blank">General Terms of Service</router-link>, <router-link to="tpmterms" target="_blank">TPM Terms of Service</router-link>, and have read our <router-link to="privacy" target="_blank">Privacy Policy</router-link>.
      </p>
      <p><i>*No credit card or payment necessary during trial</i></p>
		</div>
	</div>
</template>
<script>
import { mapActions } from 'vuex'
import SignupData from '@/structs/SignupData'
import Org from '@/structs/Org'

export default {
  name: 'SignupForm',
  data () {
    return {
      signupdata: new SignupData(),
      didSearchForOrg: false,
      didFindOrg: false,
      foundOrg: new Org(),
      validationErrors: {
        fname: null,
        lname: null,
        email: null,
        password: null,
        password_confirm: null,
        org_name: null,
        org_website: null,
        org_type: null
      },
      formStatus: {
        success: null,
        error: null,
        statusHeading: null,
        statusBody: null
      }
    }
  },
  computed: {
    showFormStatusMessage () {
      return this.formStatus.success || this.formStatus.error
    },
    submitButtonText () {
      if (this.didFindOrg === true) {
        return 'Request to Join Organization'
      } else {
        return 'Signup'
      }
    }
  },
  methods: {
    ...mapActions('auth', ['signup']),
    ...mapActions('org', ['findByWebsite']),
    submit () {
      if (this.validateForm()) {
        this.signup(this.signupdata)
          .then(response => { this.markSuccess() })
          .catch(response => { this.markError(response.message) })
      }
    },
    clearFormStatus () {
      this.formStatus.success = null
      this.formStatus.error = null
      this.statusHeading = null
      this.statusBody = null
    },
    markSuccess () {
      this.clearFormStatus()

      this.formStatus.statusHeading = 'Success!'
      this.formStatus.statusBody = 'An email has been sent to you containing a link to activate your account.  If you do not see the email in your inbox, please check your SPAM folder or contact us directly.'
      this.formStatus.success = true
    },
    markError (message) {
      console.log(message)
      this.clearFormStatus()

      this.formStatus.statusHeading = 'Error'
      this.formStatus.statusBody = (message || 'Unable to create new user and/or organization.')
      this.formStatus.error = true
    },
    clearValidationErrors () {
      for (var k in this.validationErrors) {
        this.validationErrors[k] = null
      }
    },
    validateForm () {
      this.clearValidationErrors()

      if ((this.signupdata.fname || '') === '') {
        this.validationErrors.fname = 'Empty or invalid first name'
        return false
      }

      if ((this.signupdata.lname || '') === '') {
        this.validationErrors.lname = 'Empty or invalid last name'
        return false
      }

      if ((this.signupdata.email || '') === '') {
        this.validationErrors.email = 'Empty or invalid email'
        return false
      }

      if ((this.signupdata.password || '') === '') {
        this.validationErrors.password = 'Empty or invalid password'
        return false
      }

      if ((this.signupdata.password_confirm || '') === '') {
        this.validationErrors.password_confirm = 'Empty or invalid password confirm'
        return false
      }

      if (this.signupdata.password !== this.signupdata.password_confirm) {
        this.validationErrors.password = 'Passwords must match'
        this.validationErrors.password_confirm = 'Passwords must match'
        return false
      }

      if (this.signupdata.password.length < 6) {
        this.validationErrors.password_confirm = 'Passwords must be at least 6 characters'
        return false
      }

      if ((this.signupdata.org_website || '') === '') {
        this.validationErrors.org_website = 'Empty or invalid organization website'
        return false
      }

      if ((this.signupdata.org_orgid || '') !== '') {
        if ((this.signupdata.org_name || '') === '') {
          this.validationErrors.org_name = 'Empty or invalid organization name'
          return false
        }

        if ((this.signupdata.org_type || '') === '') {
          this.validationErrors.org_type = 'Empty or invalid organization type'
          return false
        }
      }

      return true
    },
    resetOrgSearch () {
      this.foundOrg = new Org()
      this.signupdata.org_name = ''
      this.signupdata.org_type = ''
      this.signupdata.org_orgid = ''
      this.didFindOrg = false
    },
    searchForOrg () {
      this.resetOrgSearch()

      if ((this.signupdata.org_website || '') !== '') {
        this.findByWebsite({ website: this.signupdata.org_website })
          .then(org => {
            this.foundOrg = org
            this.signupdata.org_name = this.foundOrg.name
            this.signupdata.org_type = this.foundOrg.type
            this.signupdata.org_orgid = this.foundOrg.id
            this.didFindOrg = true
          })
          .catch(err => {
            console.log(err)
            this.didFindOrg = false
            this.foundOrg = new Org()
          })
          .then(() => { this.didSearchForOrg = true })
      }
    }
  }
}

</script>
